__turbopack_context__.v({
  "dropdown": "filters-module-scss-module__Y47EyG__dropdown",
  "dropdownButton": "filters-module-scss-module__Y47EyG__dropdownButton",
  "dropdownItem": "filters-module-scss-module__Y47EyG__dropdownItem",
  "dropdownList": "filters-module-scss-module__Y47EyG__dropdownList",
  "dropdownToggle": "filters-module-scss-module__Y47EyG__dropdownToggle",
  "filters": "filters-module-scss-module__Y47EyG__filters",
  "open": "filters-module-scss-module__Y47EyG__open",
  "options": "filters-module-scss-module__Y47EyG__options",
  "optionsWrapper": "filters-module-scss-module__Y47EyG__optionsWrapper",
});
